import { render, staticRenderFns } from "./UserAbsencesAdministration.vue?vue&type=template&id=2a82c5f0"
import script from "./UserAbsencesAdministration.vue?vue&type=script&lang=js"
export * from "./UserAbsencesAdministration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})


/* hot reload */
if (module.hot) {
  var api = require("G:\\Azure-Agent\\_work\\25\\s\\packages\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a82c5f0')) {
      api.createRecord('2a82c5f0', component.options)
    } else {
      api.reload('2a82c5f0', component.options)
    }
    module.hot.accept("./UserAbsencesAdministration.vue?vue&type=template&id=2a82c5f0", function () {
      api.rerender('2a82c5f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Administration/UserAbsencesAdministration.vue"
export default component.exports